import React, { createContext, useContext, useState } from "react";

const EventContext = createContext();

export const EventProvider = ({ children }) => {
  const [listeners, setListeners] = useState([]);
  const [emitReady, setEmitReady] = useState(false);

  const subscribe = listener => {
    setListeners(prevListeners => [...prevListeners, listener]);
    const unsubscribe = () => {
      setListeners(prevListeners => prevListeners.filter(l => l !== listener));
    };
    return { unsubscribe, listener };
  };

  const emit = (eventName, eventData) => {
    listeners.forEach(listener => {
      listener(eventName, eventData);
    });
  };

  return (
    <EventContext.Provider value={{ subscribe, emit }}>
      {children}
    </EventContext.Provider>
  );
};

export const useEventEmitter = () => useContext(EventContext);
